angular
    .module('festzelt-os.components')
    .config([
        '$httpProvider',
        interceptor
    ]);

function interceptor($httpProvider) {
    $httpProvider.interceptors.push([
        'Env',
        '$injector',
        '$q',
        '$window',
        'Alert',
        function (Env, $injector, $q, $window, Alert) {
            return {
                request: function (request) {
                    if (Env.version) {
                        request.headers['X-Festzelt-OS-Version'] = Env.version;
                    }
                    return request;
                },
                responseError: function (rejection) {
                    if (rejection.status === 409 && rejection.data.code === 'version-conflict') {

                        // @todo new alert translation (auth.update_available)
                        Alert.animatedAlert(
                            "Update Available: " +  Env.version,
                            "You are running an outdated version of Festzelt OS in your browser, so we cannot proceed. Please reload this page to continue. If this warning persists, try clearing your browser cache. We generally recommend using Chrome as a browser.",
                            'attention',
                            {
                                confirmButtonText: "Reload page now",
                                cancelButtonText: "Refresh later"
                            }
                        );
                    }
                    return $q.reject(rejection);
                }
            };
        }
    ]);
}



// WEBPACK FOOTER //
// ./src/app/pages/auth/version-conflict-intercepts.js